export default __webpack_public_path__ + "static/board-meetroom-ff31182e623a9f9f5b931e8e21d5cd41.jpg";